<template>
	<v-dialog v-model="show5GDialog" width="600" persistent>
		<v-card class="pb-4">
			<v-card-title class="primary">
				<span class="white--text">5G Order Details</span>
			</v-card-title>

			<v-card-text class="subtitle-1 pb-0 pt-4">
				<div style="overflow-x: auto;">
					<div class="details-wrapper">
						<div class="name text-right py-1">Account Number:</div>
						<div class="name py-1 ml-2">{{ details5GOrder.accountNumber }}</div>

						<div class="name text-right py-1">Customer Name:</div>
						<div class="name py-1 ml-2">{{ details5GOrder.customerName }}</div>

						<div class="name text-right py-1">Address:</div>
						<div class="name py-1 ml-2">{{ details5GOrder.address }}</div>

						<div class="name text-right py-1">MSN:</div>
						<div class="name py-1 ml-2">{{ details5GOrder.msn }}</div>

						<div class="name text-right py-1">SIM:</div>
						<div class="name py-1 ml-2">{{ details5GOrder.sim }}</div>

						<div class="name text-right py-1">Status Reply:</div>
						<div class="name py-1 ml-2">{{ details5GOrder.statusReply }}</div>
					</div>
				</div>
			</v-card-text>

			<v-card-actions class="mt-2">
				<v-spacer></v-spacer>
				<v-btn
					class="mr-3 primary"
					@click="$emit('close')"
					>Close</v-btn
				>
			</v-card-actions>
		</v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "Details5G",
  props: {
    show5GDialog: { type: Boolean },
    details5GOrder: { type: Object, required: true }
  }
}
</script>

<style lang="scss" scoped>
.name {
	width: 250px;
	display: inline-block;
}
</style>